import React, { ReactElement } from 'react';
import {
  Heading, Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import './verzieModulov.scss';
import ModulVerziaItem from '../../model/ModulVerziaItem';

interface Props {
  data: ModulVerziaItem[] | null | undefined;
}

const formatDate = (value: string): string => {
  if (/^\d{1,2}\.\d{1,2}\.\d{4}$/.test(value)) return value;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
};

const VerzieModulov = ({ data }: Props): ReactElement => (
  <div className="verzie-modulov">
    <Heading size="xl" className="verzie-modulov__heading">
      Verzie modulov Slov-Lexu
    </Heading>
    {data && (
      <Table className="verzie-modulov__table">
        <Thead>
          <Tr>
            <Th scope="col">Modul</Th>
            <Th scope="col">Verzia</Th>
            <Th scope="col">Dátum nasadenia</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={`verzieModulovKey-${item.nazov}`}>
              <Td>{item.nazov}</Td>
              <Td className={item.chyba ? 'verzie-modulov__chyba' : undefined}>
                {item.chyba ? 'Nedostupný' : item.verzia}
              </Td>
              <Td>{item.chyba || !item.deployTime ? '—' : formatDate(item.deployTime)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    )}
  </div>
);

export default VerzieModulov;
